import { z } from 'zod';
import { RUN_STATUSES, RUN_TRIGGERS, statusToApi, triggerToApi } from './vocab';

export const RUNS_PAGE_SIZE = 25;

/** The history's view, kept in the URL; a run carries it for the way back. */
export const runsSearchSchema = z.object({
  source: z.uuid().optional().catch(undefined),
  status: z.enum(RUN_STATUSES).optional().catch(undefined),
  trigger: z.enum(RUN_TRIGGERS).optional().catch(undefined),
  page: z.coerce.number().int().min(1).default(1).catch(1),
});

export type RunsSearch = z.output<typeof runsSearchSchema>;

export const noFilters: Partial<RunsSearch> = {
  source: undefined,
  status: undefined,
  trigger: undefined,
};

export const hasFilters = (search: RunsSearch): boolean =>
  !!(search.source || search.status || search.trigger);

export function toApiQuery(search: RunsSearch) {
  return {
    sourceId: search.source,
    status: search.status ? statusToApi(search.status) : undefined,
    trigger: search.trigger ? triggerToApi(search.trigger) : undefined,
    pageNumber: search.page,
    pageSize: RUNS_PAGE_SIZE,
  };
}
